import type { ListCatalogsResponse } from '@psw/shared';
import { Catalog } from '../Models/Catalog';
import { FetchService } from '../services/fetch.service';
import { type PswQueryOptions, usePswQuery } from './queries';

const catalogsQueriesKeys = {
  catalogs: ['catalogs'] as const,
};

// =====================================================================================================================
// List catalogs
// =====================================================================================================================

const transformCatalogsResponse = (data: ListCatalogsResponse) => {
  return data.map(d => ({
    organization: d.organization,
    catalogs: d.catalogs.map(c => new Catalog({ ...c, organization: d.organization })),
  }));
};

export function useCatalogs(
  options?: PswQueryOptions<ListCatalogsResponse, { organization: string; catalogs: Catalog[] }[]>,
) {
  return usePswQuery({
    ...options,
    queryKey: catalogsQueriesKeys.catalogs,
    queryFn: () => FetchService.get<ListCatalogsResponse>('/catalogs'),
    select: transformCatalogsResponse,
  });
}
